const constants = {
  dateTimeFormat: "YYYY-MM-DD hh:mm A",
  enDateTimeFormat: "DD/MM/YYYY, hh:mm A",
  dateFormat: "YYYY-MM-DD",
  timeFormat: "hh:mm a",
  timeFormat24: "HH:mm",
  dayFullName: "dddd",
  dayShortName: "ddd",
  currencyBy: 100,
  defaultPage: 1,
  defaultLimit: 10,
  titleBase: " | Swvl Dashboard",
  unixFormat: "x",
  bulkcreditsSizeLimit: 265 * 1024,
  notificationDelay: 3 * 1000, // 30 seconds
  ticketNotificationDelay: 0, // Never hide
  tarnsferSeat: 1,
  refundPercentage: 1,
  defaultReportType: "captainRating",
  utcTimeZoneFromMachineTimeZone: new Date().getTimezoneOffset() / 60, // Return -2 for Egypt as Egypt is +2
  toMillseconds: 1000,
  toKiloMeters: 1000,
  twoHoursTime: 2 * 60 * 60 * 1000, // 2 hours
  tableLimitOptions: [10, 20, 50, 100, 300, 500],
  checkDurationPeriod: 3 * 60 * 1000, // 3 minutes
  godsViewInterval: 3 * 1000, // 30 seconds
  fromMinToMilli: 60 * 1000,
  fromMilliToMin: 60 * 1000,
  fromHourToMilli: 60 * 60 * 1000,
  fromDayToMilli: 60 * 60 * 1000 * 24,
  fromMegaToByte: 1024 * 1024,
  utilizationComplete: 100,
  utilizationWarn: 40,
  utilizationsuccess: 75,
  percentage: 100,
  defaultTrimWordsCount: 3,
  pureCloudClientId: "2271b189-553d-4919-a5df-ceb016462eaf",
  pureCloudClientRedirectUri: "/redirector/",
  endDateRegex: /^end_.+/g,
  descSortRegex: /^-/g,
  NA: "N/A",
  languages: [
    { name: "Arabic", code: "ar", direction: "rtl" },
    { name: "English", code: "en", direction: "ltr" },
    { name: "Urdu", code: "ur", direction: "rtl" },
  ],

  RegExp: {
    email:
      '^(([^<>()\\[\\]\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
    phone: "\\+*\\d{10,}",
    md5: "^[a-fA-F0-9]{32}$",
  },
  marketplaceURL: "https://marketplace-dashboard.swvl.io/",
  boardingCheckinLevels: {
    ride: "Ride",
    corporate: "Corporate",
    schedule: "Schedule",
    category: "Category",
  },
};

export default constants;



// WEBPACK FOOTER //
// ./src/core/constants.js